import { Suspense } from 'react';

import { Outlet, useSearchParams } from 'react-router-dom';

import { Box } from '@mui/material';

import { ProductDemoBanner } from '~modules/product-demo/product-demo-banner';
import { ProductDemoMobileBadge } from '~modules/product-demo/product-demo-mobile-badge';

import { BottomNavigation } from '~components/layout/bottom-navigation/bottom-navigation';

import { useScrollToFromUrl } from '~hooks/layout/use-scroll-to-from-url';

import { Header } from './header/header';
import { LessorSidebar } from './sidebar/lessor-sidebar';

export const LessorLayout = () => {
  const [, setSearchParams] = useSearchParams();
  useScrollToFromUrl(setSearchParams);

  return (
    <Box>
      <Box
        sx={{
          display: 'flex',
        }}
      >
        <LessorSidebar />
        <Box sx={{ width: { xs: '100%', md: 'calc(100% - 268px)' } }}>
          <Header />
          <ProductDemoBanner />
          <Suspense fallback={null}>
            <Outlet />
          </Suspense>
        </Box>

        <BottomNavigation />
        <ProductDemoMobileBadge />
      </Box>
    </Box>
  );
};
